import { Component, Host, Prop, h } from '@stencil/core';

import { HierarchicalData, ReplacementVehicleOptions, RvLookingForData } from '../../../interfaces/interface.lookup';
import EventBus from '../../../services/service.eventBus';

@Component({
  tag: 'contact-information',
  styleUrl: 'contact-information.css',
  shadow: true,
})
export class ContactInformation {
  @Prop() formErrors: Set<string>;
  @Prop() fieldErrors: Set<string>;
  @Prop() showFormValidation: boolean;
  @Prop() contactFirstName: string = '';
  @Prop() contactLastName: string = '';
  @Prop() contactEmail: string = '';
  @Prop() contactPhone: string = '';
  @Prop() contactZip: string = '';
  @Prop() contactAdditionalComment: string = '';
  @Prop() dealerName: string = '';
  @Prop() contactLegalAcceptance: boolean = false;
  @Prop() replacementIsLookingForReplacementVehicle: boolean = false;
  @Prop() replacementIsLookingForNewCars: boolean = false;
  @Prop() replacementIsLookingForCertifiedCars: boolean = false;
  @Prop() replacementIsLookingForUsedCars: boolean = false;
  @Prop() replacementMinYear: number = 1990;
  @Prop() replacementMaxYear: number = new Date().getFullYear() + 1;
  @Prop() replacementMakeModelId: string = '';
  @Prop() replacementMakeId: string = '';
  @Prop() replacementYearRangeMin: number = 1990;
  @Prop() replacementYearRangeMax: number = new Date().getFullYear() + 1;
  @Prop() replacementMakesModels: HierarchicalData[] = [];
  @Prop() rvLookingForOptions: RvLookingForData[] = [];
  @Prop() replacementVehicleOptions?: ReplacementVehicleOptions = null;
  @Prop() showReplacementVehicleSection: boolean = true;
  @Prop() answerValueForLeadTypeNo: string;
  @Prop() theme: string = '';
  @Prop() isKelleyBuysYourCarRequested: boolean = false;
  @Prop() isKelleyBuysYourCarFakeDoor: boolean = false;
  @Prop() isInstantCashOfferRequested: boolean = true;
  @Prop() showOnlyConsent: boolean = false;
  @Prop() showAdditionalComment: boolean = false;
  @Prop() showLegalAcceptance: boolean = true;
  @Prop() showLegalText: boolean = true;
  @Prop() isConsumerOffer: boolean = true;
  @Prop() overrideHeaderText: string = '';
  @Prop() overrideSubHeaderText: string = '';

  componentDidLoad() {
    EventBus.publish('ComponentHasLoaded', 'contact-information');
  }

  render() {
    return (
      <Host data-testId="contactInformation">
        <div class={`${this.theme}-theme`}>
          <customer-contact
            class="font-open-sans"
            showFormValidation={this.showFormValidation}
            formErrors={this.formErrors}
            fieldErrors={this.fieldErrors}
            contactFirstName={this.contactFirstName}
            contactLastName={this.contactLastName}
            contactEmail={this.contactEmail}
            contactPhone={this.contactPhone}
            contactZip={this.contactZip}
            dealerName={this.dealerName}
            theme={this.theme}
            contactLegalAcceptance={this.contactLegalAcceptance}
            replacementIsLookingForReplacementVehicle={this.replacementIsLookingForReplacementVehicle}
            replacementIsLookingForNewCars={this.replacementIsLookingForNewCars}
            replacementIsLookingForCertifiedCars={this.replacementIsLookingForCertifiedCars}
            replacementIsLookingForUsedCars={this.replacementIsLookingForUsedCars}
            replacementMinYear={this.replacementMinYear}
            replacementMaxYear={this.replacementMaxYear}
            replacementMakeModelId={this.replacementMakeModelId}
            replacementMakeId={this.replacementMakeId}
            replacementYearRangeMin={this.replacementYearRangeMin}
            replacementYearRangeMax={this.replacementYearRangeMax}
            replacementMakesModels={this.replacementMakesModels}
            rvLookingForOptions={this.rvLookingForOptions}
            replacementVehicleOptions={this.replacementVehicleOptions}
            showReplacementVehicleSection={this.showReplacementVehicleSection}
            answerValueForLeadTypeNo={this.answerValueForLeadTypeNo}
            isKelleyBuysYourCarRequested={this.isKelleyBuysYourCarRequested}
            isKelleyBuysYourCarFakeDoor={this.isKelleyBuysYourCarFakeDoor}
            isInstantCashOfferRequested={this.isInstantCashOfferRequested}
            showOnlyConsent={this.showOnlyConsent}
            showAdditionalComment={this.showAdditionalComment}
            contactAdditionalComment={this.contactAdditionalComment}
            showLegalAcceptance={this.showLegalAcceptance}
            showLegalText={this.showLegalText}
            isConsumerOffer={this.isConsumerOffer}
            overrideHeaderText={this.overrideHeaderText}
            overrideSubHeaderText={this.overrideSubHeaderText}>
            <div slot="captcha">
              <slot name="captcha" slot="captcha" />
            </div>
          </customer-contact>
        </div>
      </Host>
    );
  }
}
